import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from 'react-aria-components/I18nProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// Autoalojadas con Fontsource: sin pedirle nada a fonts.googleapis.com en
// cada carga, ver rules/marca.md.
import '@fontsource/atkinson-hyperlegible-next/400.css';
import '@fontsource/atkinson-hyperlegible-next/500.css';
import '@fontsource/atkinson-hyperlegible-next/700.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import App from './app/App';
import { siteTitle } from './config/site';
import { registerAudioCacheWorker } from './services/audio-cache-worker';
import { registerSystemEventTrackers } from './services/telemetry/system-event-trackers';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('No se encontró el contenedor principal de la aplicación.');

document.title = siteTitle();
void registerAudioCacheWorker();
registerSystemEventTrackers();

createRoot(root).render(
  <StrictMode>
    <I18nProvider locale="es-ES">
      <App />
    </I18nProvider>
  </StrictMode>,
);
